export default "__VITE_ASSET__c1e4042a__"